import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls';
import { useAccessRoleUIContext } from './AccessRoleUIContext';
import AccessRoleTable from './access-role-table/AccessRoleTable';
import { AccessRoleFilter } from './access-role-table/access-role-filter/AccessRoleFilter'
import { BlockOrg, RoleChecker } from '../../../../RoleChecker';

export const AccessRoleCard = () => {

	const accessRoleUIContext = useAccessRoleUIContext();
	const accessRoleUIProps = useMemo(() => {
		return {
			newAccessRoleButtonClick: accessRoleUIContext.newAccessRoleButtonClick,
		};
	}, [accessRoleUIContext]);

	return (
		<Card>
			<CardHeader title="Access Role List">
				<CardHeaderToolbar>
					{BlockOrg() && RoleChecker('Create', 'access_role') && <button
						type="button"
						className="btn btn-primary"
						onClick={accessRoleUIProps.newAccessRoleButtonClick}
					>Access Role Baru
					</button>}
				</CardHeaderToolbar>
			</CardHeader>
			<CardBody>
				<AccessRoleFilter />
				<AccessRoleTable />
			</CardBody>
		</Card>
	);
};
